// extracted by mini-css-extract-plugin
export default {"logo":"Logo_logo__Oql-r","logoLink":"Logo_logoLink__F4JzM","logoSvg":"Logo_logoSvg__hJDmu","logoSvgSmall":"Logo_logoSvgSmall__IKN3g"};